import React, { forwardRef, useImperativeHandle, useRef } from "react";
import { Field, ErrorMessage } from "formik";

const CMSFormDate = forwardRef((props, ref) => {
  const {
    name,
    label,
    form,
    required,
    autoFocus,
    hideError = false,
    placeholder,
    className,
    textHidden,
    disabled = false,
    min,
    max,
    ...rest
  } = props;

  const wrapperRef = useRef(null);
  const inputRef = useRef(null);

  // Compute today's date (YYYY-MM-DD)
  const today = new Date().toISOString().split("T")[0];

  // Expose scrollIntoView & focus to parent
  useImperativeHandle(ref, () => ({
    scrollIntoView: () => {
      wrapperRef.current?.scrollIntoView({ behavior: "smooth", block: "center" });
    },
    focus: () => {
      inputRef.current?.focus();
      inputRef.current?.showPicker?.(); // open the calendar programmatically (Chrome/Edge)
    },
  }));

  const handleClick = () => {
    // Automatically open the native date picker
    inputRef.current?.showPicker?.();
  };

  return (
    <div ref={wrapperRef} className="form-group w-full flex flex-col relative">
      <label
        htmlFor={name}
        className={`text-[19px] lg:text-21pt text-green text-nowrap ${
          textHidden ? "opacity-0" : ""
        } ${required ? "required" : "notRequired"} ${
          form.touched[name] && form.errors[name] ? "isInvalidText" : ""
        }`}
      >
        {label} {required  && <span className="text-20pt text-orange">*</span>}
      </label>

      <Field name={name}>
        {({ field }) => (
          <input
            {...field}
            id={name}
            ref={inputRef}
            type="date"
            autoFocus={autoFocus}
            placeholder={placeholder}
            disabled={disabled}
            min={min || today}
            max={max}
            onClick={handleClick} // 👈 triggers picker on click
            className={`form-control bg-white font-mono  w-full h-[56px] px-4 rounded-[15px] text-left border border-green mt-1 text-18pt
              focus:outline-none focus:ring-2 focus:ring-green focus:ring-opacity-50
              ${className ? className : "2.5xl:max-w-[354px]"}
              ${disabled ? "bg-gray-200 cursor-not-allowed" : ""}
              ${form.touched[name] && form.errors[name] ? "is-invalid" : ""}`}
            {...rest}
          />
        )}
      </Field>

      {!hideError && form.touched[name] && form.errors[name] && (
        <span id={`${name}-error`} className="errorMessage">
          <ErrorMessage name={name} />
        </span>
      )}
    </div>
  );
});

export default CMSFormDate;
